import { Store } from '@ngrx/store'
import { Component, OnInit, OnDestroy } from '@angular/core'
import { FetchSettingsRequest } from '@containers/settings/settings.actions'

@Component({
  selector: 'app-digitization',
  templateUrl: './digitization.component.html',
  styleUrls: ['./digitization.component.css'],
})
export class DigitizationComponent implements OnInit, OnDestroy {
  constructor(private store: Store<any>) {}

  ngOnInit() {}

  ngOnDestroy() {}
}
